export default __webpack_public_path__ + "static/media/Path 1462@2x.ebf44242.png";